/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatPumpToolsRequestPost } from '../../models/heat-pump-tools-request-post';
import { HeatPumpToolsResponse } from '../../models/heat-pump-tools-response';

export interface ParamsControllerHeatPumpTools$Params {
      body: HeatPumpToolsRequestPost
}

export function paramsControllerHeatPumpTools(http: HttpClient, rootUrl: string, params: ParamsControllerHeatPumpTools$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatPumpToolsResponse>> {
  const rb = new RequestBuilder(rootUrl, paramsControllerHeatPumpTools.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatPumpToolsResponse>;
    })
  );
}

paramsControllerHeatPumpTools.PATH = '/planning-projects/v1-develop/params/heat-pump-tools';
